import { render, staticRenderFns } from "./RulesTab.vue?vue&type=template&id=3a50171a&scoped=true&"
import script from "./RulesTab.vue?vue&type=script&lang=js&"
export * from "./RulesTab.vue?vue&type=script&lang=js&"
import style0 from "./RulesTab.vue?vue&type=style&index=0&id=3a50171a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50171a",
  null
  
)

export default component.exports